import React from 'react'
import { DocumentTextIcon } from '@heroicons/react/24/outline'
import { Route, Routes } from 'react-router-dom'
import { RouteElement } from '../../../interfaces/_common'
import { SubMenuTabs } from '../common'
import ArticleList from './ArticleList'
import CreateArticle from './CreateArticle'
import EditArticle from './EditArticle'
import RouteKeys from 'constants/route-keys'

const _routes: RouteElement[] = [
    {
        // empty string so the list renders at /articles
        route: '',
        title: 'Articles',
        key: RouteKeys.ARTICLE,
        component: ArticleList,
        icon: DocumentTextIcon,
        display: true,
    },
]

const Articles = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    {_routes.map((route) => (
                        <React.Fragment key={'articles-frag-' + route.route}>
                            {/* main list ('' means '/articles') */}
                            <Route
                                path={route.route}
                                key={'articles' + route.route}
                                element={<route.component />}
                            />
                            {/* nested create and edit paths */}
                            <Route path="create" key="articles-create" element={<CreateArticle />} />
                            {/* support both /articles/:id/edit and /articles/edit/:id */}
                            <Route path=":id/edit" key="articles-edit-id" element={<EditArticle />} />
                            <Route path="edit/:id" key="articles-edit" element={<EditArticle />} />
                        </React.Fragment>
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default Articles